import { Button, Stack } from "@mui/material";
import { Fragment } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import usePut from "../../../../../../../../hooks/usePut";
import { PRICES_BASE_REQUEST } from "../../../../../../../../enums/ApiPaths";
import { SERVICES } from "../../../../../../../../enums/QueryKeys";
import CheckboxForm from "../../../../../../../../components/form/CheckboxForm";
import { useQueryClient } from "@tanstack/react-query";
import ServiceDurationForm from "./ServiceDurationForm";

export default function Other({ price, clinicId }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const editPath = PRICES_BASE_REQUEST + clinicId;
  const edit = usePut(editPath, SERVICES + clinicId);

  const methods = useForm();

  const submitData = async () => {
    const data = methods.watch();
    var obj = {
      ...price,
      mandatoryDescription: data?.mandatoryDescription,
      duration: data?.duration,
    };
    const res = await edit.submitCallback(obj);
    if (res) {
      methods.reset(data);
      queryClient.invalidateQueries(SERVICES + clinicId);
    }
  };

  return (
    <Fragment>
      <form onSubmit={methods.handleSubmit(submitData)}>
        <FormProvider {...methods}>
          <Stack spacing={2}>
          <CheckboxForm
            hasBorder={true}
            label={"MandatoryDescription"}
            hint={"MandatoryDescriptionHint"}
            name="mandatoryDescription"
            defaulVal={price?.mandatoryDescription}
          />
          <ServiceDurationForm
            defaultValue={price?.duration || 30}
            hint="ServiceDurationHint"
          />
          <Stack direction={"row"} alignItems={"center"} spacing={2} mt={2}>
            <Button
              variant="contained"
              color="info"
              sx={{ mt: 2 }}
              type="submit"
            >
              {t("Save")}
            </Button>
          </Stack>
          </Stack>
        </FormProvider>
      </form>
    </Fragment>
  );
}
